import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ImportPropertiesControls } from 'components/explore/import/importProperties';
import { LoadingOverlayWrapper } from 'components/layout';
import { ImportStatus } from 'components/explore/import/importStatus';
import { ImportPropertyHistoryGrid } from 'components/explore/import/importPropertyHistory';
import { ImportNav } from 'components/underwrite/shared/import';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { RouteWithTitle } from 'routes';
import { Constants } from 'utilities/constants';
import StoreMallDirectoryIcon from '@material-ui/icons/StoreMallDirectory';
import InfoIcon from '@material-ui/icons/Info';
import HistoryIcon from '@material-ui/icons/History';
import { importModuleStateSelector } from 'store/selectors';

const ExploreImport = ({ classes, match, importLoadingOverlayState }) => {
  const renderImportProperty = () =>
    <LoadingOverlayWrapper
      className={classes.overlay}
      active={importLoadingOverlayState?.isLoading}
      message={importLoadingOverlayState.message}
    >
      <ImportPropertiesControls/>
    </LoadingOverlayWrapper>;

  const renderImportPropertyHistory = () => <>
    <LoadingOverlayWrapper
      className={classes.overlay}
      active={importLoadingOverlayState?.isLoading}
      message={importLoadingOverlayState.message}
    >
      <ImportPropertyHistoryGrid/>
    </LoadingOverlayWrapper>
  </>;

  return (
    <div className={classes.root}>
      <ImportNav 
        moduleName={Constants.Module.EXPLORE}
        pages={[
          { title: 'Property Import', route: Constants.Routes.EXPLORE_IMPORT_PROPERTY, icon: <StoreMallDirectoryIcon /> },
          { title: 'Property Import History', route: Constants.Routes.EXPLORE_IMPORT_PROPERTY_HISTORY, icon: <HistoryIcon /> },
          { title: 'Import Status', route: Constants.Routes.EXPLORE_IMPORT_STATUS, icon: <InfoIcon /> },
        ]}
      />
      <div className={classes.content}>
        <Switch>
          <RouteWithTitle exact path={Constants.Routes.EXPLORE_IMPORT_PROPERTY} title={Constants.RouteTitles.EXPLORE_IMPORT_PROPERTY} render={renderImportProperty} />
          <RouteWithTitle exact path={Constants.Routes.EXPLORE_IMPORT_PROPERTY_HISTORY} title={Constants.RouteTitles.EXPLORE_IMPORT_PROPERTY_HISTORY} render={renderImportPropertyHistory} />
          <RouteWithTitle exact path={Constants.Routes.EXPLORE_IMPORT_STATUS} title={Constants.RouteTitles.EXPLORE_IMPORT_STATUS} component={ImportStatus} />
          <Route 
            render={() => {
              return <Redirect to={Constants.Routes.EXPLORE_IMPORT_PROPERTY} />; //  /Property is the default route
            }}
          />
        </Switch>
      </div>
    </div>
  );
};

const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%'
  },
  content: {
    height: 'calc(100vh - (100vh - 100%) - 48px)',
    width: 'calc(100vw - (100vw - 100%) - 48px)',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  },
  overlay: {
    height: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
});

const mapStateToProps = state => {
  const exploreImportState = importModuleStateSelector(state, Constants.Module.EXPLORE);
  return {
    importLoadingOverlayState: exploreImportState.importLoadingOverlayState,
  }
}

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, null)
)(ExploreImport);